import { render, staticRenderFns } from "./Unhandled.vue?vue&type=template&id=60ba1c12&scoped=true&"
import script from "./Unhandled.vue?vue&type=script&lang=js&"
export * from "./Unhandled.vue?vue&type=script&lang=js&"
import style0 from "./Unhandled.vue?vue&type=style&index=0&id=60ba1c12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ba1c12",
  null
  
)

export default component.exports